// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17vOH","title":"Info_title__1iDpa","selects":"Info_selects__3olXT","requiredAsterisk":"Info_requiredAsterisk__3_VAb"};